import { SonarRecord } from '@ui/records';
import { SonarText } from '@ui/text';
import { usePeriscopeActions } from '@hooks';
import {
	EmailAlertRecipientType,
	PeriscopeSfEmailAlertRecipientField,
	SonarObjectType
} from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';

const visibleRecipientTypes: Record<string, boolean> = {
	[ EmailAlertRecipientType.AccountTeam ]: true,
	[ EmailAlertRecipientType.CaseTeam ]: true,
	[ EmailAlertRecipientType.Role ]: true,
	[ EmailAlertRecipientType.RoleSubordinates ]: true,
	[ EmailAlertRecipientType.User ]: true
};

const showRecipient = (type: EmailAlertRecipientType) => visibleRecipientTypes[ type ];

export interface EmailAlertRecipientFieldProps {
	record: PeriscopeSfEmailAlertRecipientField;
	parentIndex: number;
}

export const EmailAlertRecipientField: React.FC<EmailAlertRecipientFieldProps> = ({ record, parentIndex }) => {
	const { openPeriscope } = usePeriscopeActions();

	const handleClick = useCallback(() => {
		const { displayName, sonarObjectId } = record;

		openPeriscope({
			id: sonarObjectId,
			name: displayName,
			openedFromIndex: parentIndex,
			type: SonarObjectType.SalesforceField
		});
	}, [ record, openPeriscope, parentIndex ]);

	const handleParentClick = useCallback(() => {
		const { parentDisplayName, parentSonarObjectId } = record;

		openPeriscope({
			id: parentSonarObjectId,
			name: parentDisplayName,
			openLeft: true,
			openedFromIndex: parentIndex,
			type: SonarObjectType.SalesforceEntity
		});
	}, [ record, openPeriscope, parentIndex ]);

	const name =
		<>
			<SonarText weight={ 'semibold' }>{ record.displayName }</SonarText>
			{ record.recipient && showRecipient(record.recipientType) && `: ${record.recipient}` }
		</>;

	return (
		<SonarRecord
			key={ record.sonarObjectId }
			name={ name }
			onClick={ handleClick }
			onClickParent={ handleParentClick }
			parentName={ record.parentDisplayName }
			sonarObjectId={ record.sonarObjectId }
			sonarObjectType={ record.sonarObjectType } />
	);
};
